import fontSizes from './typography.json';

export default fontSizes;



// WEBPACK FOOTER //
// ./node_modules/@ux/inline-styles/variables/typography.js